<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="mobile-ruleForm card-ruleForm" label-width="104px"
            label-position="left">
            <div class="member-msg" v-if="!form.id">
              <div class="member-border">
                <el-avatar shape="circle" v-if="userInfo.headImgUrl" :src="userInfo.headImgUrl"></el-avatar>
                <el-avatar shape="circle" v-else :src="headerImg"></el-avatar>
                <div class="rows member-box">
                  <p>{{ userInfo.nickName }}</p>
                  <div class="flex-row mt5">
                    <p class="mobile">{{ userInfo.mobile ? '手机号码:' : '身份证号码:' }} {{ userInfo.mobile ? userInfo.mobile :
                      userInfo.idCardNo }}</p>
                    <p>可用余额: <span class="fontSize18">￥{{ userInfo.walletAmount }}</span></p>
                    <p class="ml20">可用积分: <span class="fontSize18">{{ userInfo.integralAmount }}</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!form.id">
              <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>基本信息</i></p>
              <el-row>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" ref="memberName" label="姓名" prop="memberName">
                    <el-input v-model="form.memberName" placeholder="请输入真实姓名" maxlength="10"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="el-form-item-update" ref="idCardNo" label="身份证号码" prop="idCardNo">
                    <el-input v-model="form.idCardNo" placeholder="请输入身份证号码" maxlength="18"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>证件上传</i></p>
              <div class="item-cards">
                <div class="idcard">
                  <div class="front card-box">
                    <imgUpload @file="getFileCardFront" :fileList="idCardFrontUrl" module="idcard"></imgUpload>
                    <p>身份证正面照</p>
                  </div>
                  <div class="back card-box">
                    <imgUpload @file="getFileCarBack" :fileList="idCardBackUrl" module="idcard"></imgUpload>
                    <p>身份证反面照</p>
                  </div>
                </div>
              </div>
              <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>备注</i></p>
              <div class="refund_box">
                <el-input type="textarea" maxlength="150" show-word-limit :rows="3" placeholder="请输入备注信息"
                  v-model="form.remark" style="padding-top: 10px;"></el-input>
              </div>
            </div>
            <div v-else>
              <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>基本信息</i></p>
              <el-form-item class="flex-row" ref="auditStatusCn" label="审核状态" prop="auditStatusCn">
                <span class="jishi">{{ form.auditStatusCn }}</span>
              </el-form-item>
              <el-form-item class="flex-row" ref="memberName" label="姓名" prop="memberName">
                {{ form.memberName }}
              </el-form-item>

              <el-form-item class="flex-row" ref="idCardNo" label="身份证号码" prop="idCardNo">
                {{ form.idCardNo }}
              </el-form-item>
              <p class="order-title-boxs mb0"><span class="blueBlock"></span><i>证件上传</i></p>
              <el-form-item class="item-cards" ref="idCardFrontUrl" prop="idCardFrontUrl">

                <div class="idcard">
                  <div class="front card-box">
                    <img :src="idCardFrontUrl" alt="" class="img">
                    <p>身份证正面照</p>
                  </div>
                  <div class="card-box" style="margin-left: 35px;">
                    <img :src="idCardBackUrl" alt="" class="img">
                    <p>身份证反面照</p>
                  </div>
                </div>
              </el-form-item>
              <div class="refund_box">
                备注
                <el-input type="textarea" maxlength="150" show-word-limit :rows="3" disabled placeholder="请输入备注信息"
                  v-model="form.remark" style="padding-top: 10px;"></el-input>
              </div>
            </div>
          </el-form>
        </div>
        <div class="drawer-footer pr24 pb10">
          <el-button @click="back">取消</el-button>
          <div class="btns" style="display: flex;align-items: center;">
            <el-button type="primary" v-if="!form.addFlag && form.addFlag != false" class="ml10"
              @click="onSubmit">申请挂失</el-button>
            <el-button type="primary" v-perm="{ key: 'memberManager', value: 'memberManager:lossApplyCancel'}"
              v-show="form.cancelFlag" class="ml10" @click="cancel">撤销</el-button>
            <el-button type="primary" v-if="form.addFlag" class="ml10" @click="reapply">重新申请</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import imgUpload from "../../components/common/modules/uploads";
import imgUploadHead from "../../components/common/modules/upload-head";
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload, imgUploadHead },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {
        id: "",
        nickName: "", //真实姓名
        mobile: "", //手机号码
        idCardNo: "", //身份证号码
        headImgUrl: "", //头像地址
        idCardFrontUrl: "", //身份证正面照片
        idCardBackUrl: "", //身份证反面照片
      },
      idCardFrontUrl: '',
      idCardBackUrl: '',
      headerImg: require("../../assets/images/headerImg.png"),
      userInfo: {}
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
      this.$emit("change", true);
      this.$refs['form'].resetFields()
    },
    editInit() {
      this.$on("set", function (org) {
        Object.assign(this.$data, this.$options.data());
        if (org) {
          this.addEditShow = true;
          this.form.memberId = org.id
          this.$api.get(this.$url.member.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.userInfo = res;

            }
          })
          this.$api.get(this.$url.member.memberLossInfo, {
            memberId: org.id
          }).then(res => {
            console.log(res, "res")
            if (res) {
              this.idCardFrontUrl = res.idCardFrontUrl;
              this.idCardBackUrl = res.idCardBackUrl;
              this.form = res;
            }
          })
            .catch(error => { });
          this.addEditTitle = "挂失申请";
        }
      });
    },
    // 上传组件成功回调
    getFile(res) {
      this.form.headImgUrl = res;
    },
    getFileCardFront(res) {
      //身份证正面
      // this.form.idCardFrontUrl = res;
      if (this.form.idCardFrontUrl) {
        this.ossMerchatDelImg({ imgUrl: this.form.idCardFrontUrl });
      }
      this.form.idCardFrontUrl = res.oldImgUrl;
      this.idCardFrontUrl = res.newImgUrl;
    },
    getFileCarBack(res) {
      //身份证反面
      // this.form.idCardBackUrl = res;
      if (this.form.idCardBackUrl) {
        this.ossMerchatDelImg({ imgUrl: this.form.idCardBackUrl });
      }
      this.form.idCardBackUrl = res.oldImgUrl;
      this.idCardBackUrl = res.newImgUrl;
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", true);
    },
    getMember() {
      this.$api.get(this.$url.member.get, {
        id: this.form.id
      }).then(res => {
        if (res) {
          this.form = res;
          this.form.memberId = res.id;
          this.userName = this.form.nickName
        }
      })
        .catch(error => { });
    },
    // 重新申请
    reapply() {
      this.idCardFrontUrl = '';
      this.idCardBackUrl = '';
      this.form = {
        memberId: this.userInfo.id,
        idCardFrontUrl:this.idCardFrontUrl , //身份证正面照片
        idCardBackUrl: this.idCardBackUrl, //身份证反面照片
      }
    },
    calcel() {
      this.centerDialogVisible = false
    },
    onSubmit(values) {
      if (!this.form.memberName) {
        return this.$message.error("请输入真实姓名")
      } else if (!this.form.idCardNo) {
        return this.$message.error("请输入身份证号码")
      } else if (!this.form.idCardFrontUrl) {
        return this.$message.error("请输入身份证正面照")
      } else if (!this.form.idCardBackUrl) {
        return this.$message.error("请输入身份证反面照")
      } else if (!this.form.remark) {
        return this.$message.error("请输入备注")
      }
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$api.post(this.$url.member.memberLossSave, this.form).then(res => {
            if (res) {
              this.addEditShow = false;
              this.$message.success("操作成功");
              this.$emit("change", true);
            }
          }).catch(error => { });
        }
      });
    },
    cancel() {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [
          h('span', { style: 'color: red' }, '确定要撤销吗?')
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(action => {
        this.$api.get(this.$url.member.memberLossCancel, { memberId: this.form.memberId }).then(res => {
          if (res) {
            this.addEditShow = false;
            this.$message.success("撤销成功");
            this.$emit("change", true);
          }
        }).catch(error => { });
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";

.img {
  width: 220px;
  height: 140px;
}

.toggle-text {
  padding: 0 20px;
}

.refund_box {
  background: #fff;
  padding: 10px 24px;

  .infos {
    color: #ff892a;
    padding-bottom: 10px;
  }
}

/deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.pay-mains {
  padding: 0;

  .card-ruleForm {
    padding-bottom: 0;
    padding-top: 10px;

    /deep/ .el-form-item {
      padding: 10px 20px;
      margin-bottom: 0;

    }

    .item-cards {
      padding: 20px;

      .idcard {
        display: flex;
        justify-content: center;

        .card-box {
          p {
            margin-top: 10px;
          }

          text-align: center;
        }


        .back {
          margin-left: 35px;
        }
      }
    }

    .el-form-item-update {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      margin: 0;
      background: #fff;

      &:first-child {
        margin-top: 0;
      }

      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
      }

      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }

      /deep/ .el-radio__label {
        font-size: 16px;
      }
    }

    .member-msg {
      padding: 16px 16px 0;

      .member-border {
        width: 100%;
        background-size: 100% 100%;
        color: white;
        display: flex;
        align-items: center;
        border-radius: 10px;
        padding: 12px 15px;
        background: #3388ff;
        box-sizing: border-box;

        .member-box {
          margin-left: 10px;

          .mobile {
            line-height: 1.6;
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>